module.exports = __webpack_public_path__ + "static/media/katarzyna-tkocz.4ec86f45.png";